import logo from '../../assets/icons/logo.svg';

const Logo = () => (
    <div className="w-10 h-10 bg-black text-white flex items-center justify-center rounded-full">
      <img src={logo} alt="logo" />
    </div>
  );
export default Logo;